module.exports = __webpack_public_path__ + "static/media/login_background.web.b745943a.png";